import { Middleware, configureStore, combineReducers } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage
import loginReducer from "../features/loginSlice";
import partReducer from "../features/partSlice";
import loaderReducer from "../features/loaderSlice";

// Persist config: you can whitelist or blacklist reducers as needed
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['login', 'part', 'loader'], // list the reducers you want to persist
};

const rootReducer = {
  login: loginReducer,
  part: partReducer,
  loader: loaderReducer,
};

const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer));

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable if needed for redux-persist or non-serializable actions
    }).concat(logger as Middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);

export default store;
